/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_BusInputs */

const en_homepage_listen_in_bus = /** @type {(inputs: Homepage_Listen_In_BusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On The Bus`)
};

const es_homepage_listen_in_bus = /** @type {(inputs: Homepage_Listen_In_BusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En el autobús`)
};

/**
* | output |
* | --- |
* | "On The Bus" |
*
* @param {Homepage_Listen_In_BusInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_bus = /** @type {((inputs?: Homepage_Listen_In_BusInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_BusInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_bus(inputs)
	return en_homepage_listen_in_bus(inputs)
});